import {
  GET_AUDIT_TICKETS,
  GET_AUDIT_TICKETS_FAIL,
  GET_AUDIT_TICKETS_SUCCESS,
  GET_EXPORT_AUDIT_TICKETS,
  GET_EXPORT_AUDIT_TICKETS_SUCCESS,
  GET_EXPORTED_AUDIT_TICKETS_FAIL,
  RESET_EXPORT_DATA,
  CLEAR_MESSAGE,
} from "./actionTypes"

export const getAuditTicktes = payload => ({
  type: GET_AUDIT_TICKETS,
  payload: { ...payload },
})

export const getAuditTicktesSuccess = audits => ({
  type: GET_AUDIT_TICKETS_SUCCESS,
  payload: audits,
})

export const getAuditTicketsFail = error => ({
  type: GET_AUDIT_TICKETS_FAIL,
  payload: error,
})

export const getExportAuditTickets = payload => ({
  type: GET_EXPORT_AUDIT_TICKETS,
  payload,
})

export const getExportAuditTicketsSuccess = AuditTicket => ({
  type: GET_EXPORT_AUDIT_TICKETS_SUCCESS,
  payload: AuditTicket,
})

export const getExportAuditTicketsFail = error => ({
  type: GET_EXPORTED_AUDIT_TICKETS_FAIL,
  payload: error,
})

export const clearMessage = () => ({
  type: CLEAR_MESSAGE,
})

export const resetExportFileData = () => ({
  type: RESET_EXPORT_DATA,
})
